import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eum officia
        quisquam temporibus voluptatum explicabo. Quas exercitationem fugit ab
        amet deserunt recusandae, impedit quia ea, hic totam corrupti.
        Blanditiis, sed minima. Facere quas ex ratione beatae quibusdam
        consequatur eum asperiores repellat.
      </p>
    </section>
  );
};

export default About;
